import React from "react";

import { COLOR } from "../component.constants";

export interface Props {
    color: COLOR;
    width?: number;
    height?: number;
    viewBoxWidth?: number;
    viewBoxHeight?: number;
}

const DocumentIcon: React.FC<Props> = ({ color, width, height, viewBoxWidth, viewBoxHeight }) => {
    return (
        <svg
            width={width ?? 24}
            height={height ?? 24}
            viewBox={`0 0 ${viewBoxWidth ?? 24} ${viewBoxHeight ?? 24}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.5 6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C6.02 3 6.58 3 7.7 3h6.364c.568 0 .852 0 1.114.073a2 2 0 0 1 .645.312c.22.16.396.383.749.828l2.236 2.823c.257.324.385.485.476.665.08.16.14.33.176.505.04.198.04.404.04.817V17.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C17.98 21 17.42 21 16.3 21H7.7c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4.5 19.48 4.5 18.92 4.5 17.8V6.2ZM8 9a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
                fill={color}
            />
        </svg>
    );
};

export default DocumentIcon;
